import { render, staticRenderFns } from "./Bemob.vue?vue&type=template&id=4a51e06c"
import script from "./Bemob.vue?vue&type=script&lang=js"
export * from "./Bemob.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports